import moneda_model from '../../../shared/models/moneda_model';
import recurso_tipo_model from '../../../shared/models/recurso_tipo_model';

export default {
  Codigo: null,
  Descripcion: null,
  CodigoRecursoTipo: null,
  CodigoRenglonEquivalente: null,
  CostoHora: null,
  CodigoUsuarioActualizacion: null,
  CodigoUsuarioCreacion: null,
  FechaActualizacion: null,
  FechaCreacion: null,
  CodigoMoneda: null,
  AnchoMaximo: null,
  LargoMaximo: null,
  LargoMaximoPlatina: null,
  PasoPlatina: null,
  CantidadCuerposImpresores: null,
  CantidadColor: null,
  TiempoPreparacionColor: null,
  Activo: true,
  CodigoTipoCilindro: null,
  CilindroTipo: null,
  Colores: null,
  RecursoTipo: { ...recurso_tipo_model },
  Moneda: { ...moneda_model },
  ProcesoRecurso: [],
};
